var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-content",staticStyle:{"margin":"0px","width":"100%"}},[(_vm.$route.name === _vm.names.MAIN)?_c('Main',{attrs:{"name_list":_vm.list}}):_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }